import { useState } from "react";
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";

export default function OrganizationBillingReceiptSectionDropdown({ title, subTitle, children }) {
    const [expanded, setExpanded] = useState(false);

    return (
        <>
            <div
                className='p-4 flex items-center cursor-pointer'
                onClick={() => setExpanded(!expanded)}
            >
                <div className="flex-1 select-none">{title}</div>

                <div className="pr-4 text-sm text-gray-500 select-none">{subTitle}</div>

                <div className="transition-transform duration-300 ease-in-out">
                    {expanded === false && <ChevronDownIcon className="h-6 w-6 text-gray-500" />}
                    {expanded === true && <ChevronUpIcon className="h-6 w-6 text-gray-500" />}
                </div>
            </div>

            <div
                className={`
                    transition-all duration-300 ease-in-out overflow-hidden divide-y divide-gray-200
                    ${expanded ? 'opacity-100' : 'max-h-0 opacity-0'}
                `}
            >
                {children}
            </div>
        </>
    )
}